import ISO9001 from "../assets/managementCertificates/ISO9001.svg";
import ISO45001 from "../assets/managementCertificates/ISO45001.svg";
import ISOICE27001 from "../assets/managementCertificates/ISOICE27001.svg";
import ISOICE20000 from "../assets/managementCertificates/ISOICE20000.svg";

export const managementCertifications = [
  ISO9001,
  ISOICE27001,
  ISO45001,
  ISOICE20000,
];
